export default __webpack_public_path__ + "static/media/easyIconDark.a731ffe5.svg";